<template>
  <div>
    <tw-header :title="$t('BreadCrumbs.Export Customs Clearance List')"></tw-header>
    <div class="tw_container">
      <tw-breadcrumbs :pages="breadcrumbs" style="margin-bottom: 40px" />
      <!-- <tw-entity-buttons /> -->

      <el-form class="search_unit compact" ref="searchUnit" :model="searchForm" label-position="top">
        <div class="row">
          <el-form-item class="max-content" :label="$t('Label.Update Datetime')" prop="processUpdateDateTime">
            <el-date-picker
              v-model="searchForm.processUpdateDateTime"
              type="datetimerange"
              range-separator="to"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="Start datetime"
              end-placeholder="End datetime">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Trading Name')" prop="tradingName">
            <el-input type="text" v-model="searchForm.tradingName" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Flow Name')" prop="flowName">
            <el-input type="text" v-model="searchForm.flowName" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Process')" prop="processTypes">
            <el-select v-model="searchForm.processTypes" :class="{multiple_selected: multipleSelect(searchForm.processTypes)}" placeholder="Select" multiple collapse-tags clearable>
              <el-option
                v-for="process in processes"
                :key="process.name"
                :label="process.name"
                :value="process.processType"
              >
                <span>{{process.name}}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Label.Process User Memo')" prop="processUserMemo">
            <el-input type="text" v-model="searchForm.processUserMemo" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-badge :value="searchConditionNum" :hidden="searchConditionNum === 0">
            <tw-button
              type="secondary"
              size="medium"
              @click="isOpenSearchDialog = true"
            >
              Advanced Search
            </tw-button>
          </el-badge>
        </div>
        <div class="row drop space_between">
          <div>
            <tw-button
              type="secondary"
              size="medium"
              icon="search"
              @click="search"
            >
              Search
            </tw-button>
            <tw-button
              type="default"
              size="medium"
              @click="clear"
              style="margin: 8px 16px 16px;"
            >
              Clear
            </tw-button>
          </div>
          <div>
            <el-dropdown trigger="click" placement="bottom" @command="onDropDownClick" :tabindex="-1">
              <tw-button class="menu_button" type="secondary" size="small" icon="menu">{{ $t('Label.View Options') }}</tw-button>
              <el-dropdown-menu class="nowrap">
                <el-dropdown-item command="openTableSettingDialog">{{ $t('Label.Column Preference') }}</el-dropdown-item>
                <el-dropdown-item command="changeTableWidth">{{ tableMode === 'show' ? $t('Label.Column Width') : $t('Label.Complete Width Edit Mode') }}</el-dropdown-item>
                <el-dropdown-item command="resetTableSetting">{{ $t('Label.Reset Column') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <tw-button
              type="secondary"
              size="small"
              style="margin-left: 10px"
              @click="tsvDownLoadClick"
            >
              {{ $t('Label.TSV Download') }}
            </tw-button>
          </div>
        </div>
      </el-form>

      <tw-table-system :schemas="showSchema" :items="items" :border="tableMode === 'changeWidth'" :pageSize="limit" :totalCount="totalCount" :offset="offset" :selection="selection" :serverPagination="true" @row-click="rowClick" @row-dbclick="rowDbClick" @paging="onPaging" @change-column-width="changeColumnWidth" />
    </div>
    <tw-table-column-setting-dialog
      :visible.sync="isOpenTableSettingDialog"
      :full-schemas="schemas"
      :show-schemas.sync="filteredSchemas"
      @close="updateColumnSetting"
    ></tw-table-column-setting-dialog>
    <el-dialog
      class="search-condition-dialog"
      :visible.sync="isOpenSearchDialog"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form
        class="search_unit compact"
        v-loading="isSearching"
        ref="searchUnit"
        :model="searchForm"
        label-position="top"
      >
        <div class="row" style="border-bottom: 1px solid #BFBFCD;margin-bottom: 12px;">
          <el-form-item class="max-content" :label="$t('Label.Update Datetime')" prop="processUpdateDateTime">
            <el-date-picker
              v-model="searchForm.processUpdateDateTime"
              type="datetimerange"
              range-separator="to"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="Start datetime"
              end-placeholder="End datetime">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Trading Name')" prop="tradingName">
            <el-input type="text" v-model="searchForm.tradingName" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Flow Name')" prop="flowName">
            <el-input type="text" v-model="searchForm.flowName" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Process')" prop="processTypes">
            <el-select v-model="searchForm.processTypes" :class="{multiple_selected: multipleSelect(searchForm.processTypes)}" placeholder="Select" multiple collapse-tags clearable>
              <el-option
                v-for="process in processes"
                :key="process.name"
                :label="process.name"
                :value="process.processType"
              >
                <span>{{process.name}}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Label.Process User Memo')" prop="processUserMemo">
            <el-input type="text" v-model="searchForm.processUserMemo" placeholder="Enter keyword"></el-input>
          </el-form-item>
        </div>
        <div class="row" style="border-bottom: 1px solid #BFBFCD;margin-bottom: 12px;">
          <el-form-item :label="$t('Label.Status')" prop="status">
            <el-select v-model="searchForm.status" :class="{multiple_selected: multipleSelect(searchForm.status)}" placeholder="Select" multiple collapse-tags clearable>
              <el-option
                v-for="status in PROCESS_PROGRESS_STATUS_VARIABLES"
                :key="status.code"
                :label="status.label"
                :value="status.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Label.Ex Custom Invoice No')" prop="invoiceNo">
            <el-input type="text" v-model="searchForm.invoiceNo" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item class="max-content" :label="$t('Label.Ex Invoice Date')" prop="invoiceDate">
            <el-date-picker
              v-model="searchForm.invoiceDate"
              type="daterange"
              range-separator="to"
              format="yyyy-MM-dd"
              :default-value="defaultDate"
              @change.native="onDateRangeChange"
              start-placeholder="Start date"
              end-placeholder="End date">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.S/I NO')" prop="siNo">
            <el-input type="text" v-model="searchForm.siNo" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Trading/Flow ID')" prop="tradingFlowId">
            <el-input type="text" v-model.trim="searchForm.tradingFlowId" placeholder="Enter keyword" class="trading-flow"></el-input>
          </el-form-item>
          <el-form-item class="max-content" :label="$t('Label.Create Datetime')" prop="processCreateDateTime">
            <el-date-picker
              v-model="searchForm.processCreateDateTime"
              type="datetimerange"
              range-separator="to"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="Start datetime"
              end-placeholder="End datetime">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Section(From)')" prop="fromSectionIds">
            <TwSelectSection v-model="searchForm.fromSectionIds" :sections="fromSections" />
          </el-form-item>
          <el-form-item :label="$t('Label.Section(To)')" prop="toSectionIds">
            <TwSelectSection v-model="searchForm.toSectionIds" :sections="toSections" />
          </el-form-item>
          <el-form-item :label="$t('Label.Ex Reference (From)')" prop="exFromReference">
            <el-input type="text" v-model="searchForm.exFromReference" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Ex Reference (To)')" prop="exToReference">
            <el-input type="text" v-model="searchForm.exToReference" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Ex PIC (From)')" prop="exFromPIC">
            <el-input type="text" v-model="searchForm.exFromPIC" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Ex PIC (To)')" prop="exToPIC">
            <el-input type="text" v-model="searchForm.exToPIC" placeholder="Enter keyword"></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item :label="$t('Label.P/O No')" prop="poNo">
            <el-input type="text" v-model="searchForm.poNo" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Contract No')" prop="contractNo">
            <el-input type="text" v-model="searchForm.contractNo" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Main Goods')" prop="goodsName">
            <el-input type="text" v-model="searchForm.contractGroupOfGoods" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Buyer')" prop="buyerName">
            <el-input type="text" v-model="searchForm.buyerName" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Maker Name')" prop="makerName">
            <el-input type="text" v-model="searchForm.makerName" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Vessel Name')" prop="nameOfVessel">
            <el-input type="text" v-model="searchForm.nameOfVessel" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.B/L No')" prop="blNo">
            <el-input type="text" v-model="searchForm.blNo" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Booking No')" prop="vesselBookingNo">
            <el-input type="text" v-model="searchForm.vesselBookingNo" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Transportation')" prop="transportation">
            <el-select v-model="searchForm.transportation" placeholder="Select" collapse-tags clearable>
              <el-option
                v-for="status in TRANSPORTATION_VARIABLES"
                :key="status.code"
                :label="status.label"
                :value="status.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Label.Type Of Service From')" prop="typeOfServiceFrom">
            <el-select v-model="searchForm.typeOfServiceFrom" placeholder="Select" collapse-tags clearable>
              <el-option
                v-for="status in TYPE_OF_SERVICE_FCL_LCL_VARIABLES"
                :key="status.code"
                :label="status.label"
                :value="status.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Label.Hazardous')" prop="hazardousFlag">
            <el-select v-model="searchForm.hazardousFlag" placeholder="Select" collapse-tags clearable>
              <el-option
                v-for="mode in HAZARDOUS_FLAG_VARIABLES"
                :key="mode.code"
                :label="mode.label"
                :value="mode.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Label.Port of Loading')" prop="portOfLoadingName">
              <el-input type="text" v-model="searchForm.portOfLoadingName" placeholder="Enter keyword"></el-input>
            </el-form-item>
          <el-form-item :label="$t('Label.ETD')" prop="loadingPortEtd">
            <el-date-picker
              v-model="searchForm.loadingPortEtd"
              type="daterange"
              range-separator="to"
              format="yyyy-MM-dd"
              :default-value="defaultDate"
              @change.native="onDateRangeChange"
              start-placeholder="Start date"
              end-placeholder="End date">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Current ETD')" prop="loadingPortCurrentEtd">
            <el-date-picker v-model="searchForm.loadingPortCurrentEtd" type="daterange" range-separator="to" format="yyyy-MM-dd" :default-value="defaultDate" @change.native="onDateRangeChange" start-placeholder="Start date" end-placeholder="End date"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.ATD')" prop="loadingPortAtd">
            <el-date-picker v-model="searchForm.loadingPortAtd" type="daterange" range-separator="to" format="yyyy-MM-dd" :default-value="defaultDate" @change.native="onDateRangeChange" start-placeholder="Start date" end-placeholder="End date"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Ex Request Declaration Date')" prop="exRequestDeclarationDate">
            <el-date-picker v-model="searchForm.exRequestDeclarationDate" type="daterange" range-separator="to" format="yyyy-MM-dd" :default-value="defaultDate" @change.native="onDateRangeChange" start-placeholder="Start date" end-placeholder="End date"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.CY CUT')" prop="cyCutDate">
            <el-date-picker v-model="searchForm.cyCutDate" type="daterange" range-separator="to" format="yyyy-MM-dd" :default-value="defaultDate" @change.native="onDateRangeChange" start-placeholder="Start date" end-placeholder="End date"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Cargo Tracking')" prop="exCargoTrackingFlg">
            <el-select v-model="searchForm.exCargoTrackingFlg" placeholder="Select" collapse-tags clearable>
              <el-option
                v-for="status in CARGO_TRACKING_FLG_VARIABLES"
                :key="status.code"
                :label="status.label"
                :value="status.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Label.Attach File')" prop="documentLink">
            <el-cascader 
              v-model="searchForm.documentLink" 
              :options="documentLinkOptions" 
              :props="{ expandTrigger: 'click'}" 
              placeholder="Select" 
              @change="handleFileSelection" 
              clearable>
            </el-cascader>
          </el-form-item>
          <el-form-item :label="$t('Label.Ex New Items')" prop="exNewGoodsFlag">
            <el-select v-model="searchForm.exNewGoodsFlag" placeholder="Select" collapse-tags clearable>
              <el-option
                v-for="status in NEW_GOODS_FLAG_VARIABLES"
                :key="status.code"
                :label="status.label"
                :value="status.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Label.Linking Status')" prop="permitLinkFlg">
            <el-select v-model="searchForm.permitLinkFlg" placeholder="Select" collapse-tags clearable>
              <el-option
                v-for="status in PERMIT_LINK_FLG_VARIABLES"
                :key="status.code"
                :label="status.label"
                :value="status.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Label.Amendment')" prop="amendmentFlg" style="margin-right: 12px">
            <el-select v-model="searchForm.amendmentFlg" placeholder="Select" collapse-tags clearable>
              <el-option
                v-for="status in AMENDMENT_FLG_VARIABLES"
                :key="status.code"
                :label="status.label"
                :value="status.code">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          
        </div>
      </el-form>
      <div slot="footer" class="row drop space_between">
        <div>
          <tw-button
            type="secondary"
            size="medium"
            icon="search"
            @click="search"
          >
            Search
          </tw-button>
          <tw-button
            type="default"
            size="medium"
            @click="clear"
            style="margin: 8px 16px 16px;"
          >
            Clear
          </tw-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import { EXPORT_CUSTOMS_SEARCH_SORT_TARGET, ENTITY_TYPE, PERMIT_LINK_FLG_VARIABLES, AMENDMENT_FLG_VARIABLES, CARGO_TRACKING_FLG_VARIABLES, TRANSPORTATION_VARIABLES, TYPE_OF_SERVICE_FCL_LCL_VARIABLES, HAZARDOUS_FLAG_VARIABLES, NEW_GOODS_FLAG_VARIABLES, DOCUMENT_LINK_VARIABLES, ATTACHED_FILE_FLG } from 'lib-tw-common';
import { $api } from '@/store/ApiClient';
import mixinEntityList from '@/utils/mixinEntityList.js';
import mixinEntity from '@/utils/mixinEntity.js';
import mixinTableSetting from '@/utils/mixinTableSetting.js';
import { collapseTransition } from '@/utils/nextFrame';
import { clearSearchForm, formatUtcDate } from '@/utils/searchUtil.js';
import schemas from '@/dictionaries/listExCustomsClearanceSchema.json';
import TwTableColumnSettingDialog from '@/components/organisms/TwTableColumnSettingDialog.vue';
import { tsvDownLoad } from '@/utils/listToTsvUtils.js';

const ENTITY_NAME = 'EX_CUSTOMS';

export default {
  name: 'ListExCustomsClearance',
  mixins: [mixinEntityList, collapseTransition, mixinEntity, mixinTableSetting],
  components: {
    TwTableColumnSettingDialog
  },
  data() {
    return {
      entityCode: ENTITY_TYPE.EX_CUSTOMS,
      schemas: schemas,
      items: null,
      searchForm: {
        tradingFlowId: '',
        tradingName: '',
        flowName: '',
        invoiceNo: '',
        invoiceDate: '',
        fromSectionIds: [],
        toSectionIds: [],
        siNo: '',
        contractGroupOfGoods: '',
        status: [],
        permitLinkFlg: null,
        amendmentFlg: null,
        exCargoTrackingFlg: null,
        documentLink: [],
        processTypes: [],
        processUserMemo: '',
        processUpdateDateTime: [],
        processCreateDateTime: [],
        exFromReference: '',
        exToReference: '',
        exFromPIC: '',
        exToPIC: '',
        poNo: '',
        blNo: '',
        contractNo: '',
        buyerName: '',
        vesselBookingNo: '',
        transportation: null,
        typeOfServiceFrom: null,
        hazardousFlag: null,
        exRequestDeclarationDate: '',
        cyCutDate: '',
        exNewGoodsFlag: null,
        loadingPortCurrentEtd: '',
        loadingPortEtd: '',
        loadingPortAtd: '',
        portOfLoadingName: '',
        nameOfVessel: '',
        makerName: ''
      },
      limit: 50,
      offset: 0,
      sort: null,
      count: 0,
      totalCount: 0,
      pageCount: 0,
      lastQuery: {},
      PERMIT_LINK_FLG_VARIABLES,
      AMENDMENT_FLG_VARIABLES,
      CARGO_TRACKING_FLG_VARIABLES,
      TRANSPORTATION_VARIABLES,
      TYPE_OF_SERVICE_FCL_LCL_VARIABLES,
      HAZARDOUS_FLAG_VARIABLES,
      NEW_GOODS_FLAG_VARIABLES,
      DOCUMENT_LINK_VARIABLES,
      isOpenTableSettingDialog: false,
      tableId: 'listExCustomsClearance',
      isSearching: false,
      isOpenSearchDialog: false
    };
  },
  computed: {
    breadcrumbs() {
      return [{ label: this.$t('BreadCrumbs.Dashboard'), to: '/' }, { label: this.$t('BreadCrumbs.Export Customs Clearance List') }];
    },
    searchConditionNum() {
      return Object.values(this.searchForm).reduce((result, val) => {
        if((Array.isArray(val) && val.length) || 
          typeof val === 'string' && val ||
          typeof val === 'number' && val !== null  
        ) {
          ++result
        }
        return result
      }, 0)
    },
    documentLinkOptions() {
      return DOCUMENT_LINK_VARIABLES.map(item => ({
        value: item.code,
        label: item.label,
        children:[
          { value: ATTACHED_FILE_FLG.ON, label: 'Attached' },
          { value: ATTACHED_FILE_FLG.OFF, label: 'Not Attached' }
        ]
      }));
    },
  },
  created() {
    const queries = this.$store.getters.getQueries(ENTITY_NAME);
    if (queries) {
      this.searchForm = {
        ...this.searchForm, ...queries, documentLink: queries.documentLink || []
      };
    }
    this.fetch();
    this.processes = this.getProcessesByEntity(ENTITY_NAME);
  },
  methods: {
    // POSTパラメータを生成します
    transformQueries() {
      const f = this.searchForm;
      const queries = {
        fromSectionIds: f.fromSectionIds,
        toSectionIds: f.toSectionIds,
        invoiceDateStartDate: this.getYMDStartDate(f.invoiceDate),
        invoiceDateEndDate: this.getYMDEndDate(f.invoiceDate),
        tradingId: this.getTradingFlowId(f.tradingFlowId)[0],
        tradingFlowId: this.getTradingFlowId(f.tradingFlowId)[1],
        loadingPortEtdFrom: this.getYMDStartDate(f.loadingPortEtd),
        loadingPortEtdTo: this.getYMDEndDate(f.loadingPortEtd),
        loadingPortCurrentEtdFrom: this.getYMDStartDate(f.loadingPortCurrentEtd),
        loadingPortCurrentEtdTo: this.getYMDEndDate(f.loadingPortCurrentEtd),
        loadingPortAtdFrom: this.getYMDStartDate(f.loadingPortAtd),
        loadingPortAtdTo: this.getYMDEndDate(f.loadingPortAtd),
        cyCutDateFrom: this.getYMDStartDate(f.cyCutDate),
        cyCutDateTo: this.getYMDEndDate(f.cyCutDate),
        exRequestDeclarationDateFrom: this.getYMDStartDate(f.exRequestDeclarationDate),
        exRequestDeclarationDateTo: this.getYMDEndDate(f.exRequestDeclarationDate),
        tradingName: f.tradingName,
        flowName: f.flowName,
        invoiceNo: f.invoiceNo,
        siNo: f.siNo,
        exFromReference: f.exFromReference,
        exToReference: f.exToReference,
        exFromPIC: f.exFromPIC,
        exToPIC: f.exToPIC,
        poNo: f.poNo,
        blNo: f.blNo,
        nameOfVessel: f.nameOfVessel,
        contractNo: f.contractNo,
        buyerName: f.buyerName,
        makerName: f.makerName,
        portOfLoadingName: f.portOfLoadingName,
        vesselBookingNo: f.vesselBookingNo,
        transportation: f.transportation,
        typeOfServiceFrom: f.typeOfServiceFrom,
        hazardousFlag: f.hazardousFlag,
        exNewGoodsFlag: f.exNewGoodsFlag,
        contractGroupOfGoods: f.contractGroupOfGoods,
        processProgressStatus: this.getProcessProgressStatus(f.status),
        documentLinkType: f.documentLink.length > 0 ? f.documentLink[0] : null,
        documentLinkFlg: f.documentLink.length > 1 ? f.documentLink[1] : null,
        processIds: f.processTypes ? _.flatten(_.map(f.processTypes, item => this.getProcessIdsByProcessType(item))) : [],
        processUserMemo: f.processUserMemo,
        permitLinkFlg: f.permitLinkFlg,
        amendmentFlg: f.amendmentFlg,
        exCargoTrackingFlg: f.exCargoTrackingFlg,
        processUpdateDateTimeFrom: f.processUpdateDateTime ? formatUtcDate(f.processUpdateDateTime[0]) : null,
        processUpdateDateTimeTo: f.processUpdateDateTime?.[1] ? formatUtcDate(f.processUpdateDateTime[1]).replace('00Z', '59Z') : null,
        processCreateDateTimeFrom: f.processCreateDateTime ? formatUtcDate(f.processCreateDateTime[0]) : null,
        processCreateDateTimeTo: f.processCreateDateTime?.[1] ? formatUtcDate(f.processCreateDateTime[1]).replace('00Z', '59Z') : null,
      };

      return {
        ...queries,
        initialViewFlag: this.initialFlag(queries),
        limit: this.limit,
        offset: this.offset,
        sort: this.sort
      };
    },
    fetch(queries) {
      this.cancelRequestSources.forEach(tag => {
        $api.cancelRequests(tag);
      });
      // bff_ec_1 輸出通関一覧検索BFF
      const params = {
        lslConfig: {
          serviceCode: 'tw-transaction-bff-api',
          apiCode: 'get_/v1/export-customs/search',
          query: queries || this.transformQueries()
        },
        tag: this.pushCancelTag()
      };

      this.lastQuery = _.cloneDeep(params.lslConfig.query);

      return $api.request(params)
        .then(res => {
          this.items = res.exportCustoms;
          this.totalCount = res.totalCount;
          return { isError: false };
        })
        .catch(err => {
          if (err.isCanceled) {
            return;
          }
          this.items = [];
          this.$store.dispatch('SHOW_ALERT', err.message);
          return { isError: true };
        });
    },
    async search() {
      this.isSearching = true;
      this.offset = 0;
      this.$store.commit('SET_QUERIES', { key: ENTITY_NAME, queries: _.cloneDeep(this.searchForm) });
      const { isError } = await this.fetch();
      this.isSearching = false;
      if (!isError) this.isOpenSearchDialog = false;
    },
    clear() {
      this.searchForm = clearSearchForm(this.searchForm);
      this.$store.commit('SET_QUERIES', { key: ENTITY_NAME, queries: _.cloneDeep(this.searchForm) });
    },
    onPaging({ target, sortType, currentPage }) {
      if (target && sortType) {
        const key = _.get(_.find(this.schemas, { key: target }), 'sortTarget');
        this.sort = {
          target: [EXPORT_CUSTOMS_SEARCH_SORT_TARGET[key] || target],
          sortType: [sortType]
        };
      } else {
        this.sort = null;
      }

      this.offset = currentPage * this.limit - this.limit;
      const queries = {
        ...this.lastQuery,
        limit: this.limit,
        offset: this.offset,
        sort: this.sort
      };
      this.fetch(queries);
    },
    // TSVダウンロード用に全件取得します
    fetchAll() {
      return new Promise((resolve, reject) => {
        // bff_ec_1 輸出通関一覧検索BFF
        const params = {
          lslConfig: {
            serviceCode: 'tw-transaction-bff-api',
            apiCode: 'get_/v1/export-customs/search',
            query: { ...this.transformQueries(), offset: undefined, limit: undefined }
          }
        };

        $api
          .request(params)
          .then(res => {
            resolve(res.exportCustoms);
          })
          .catch(err => {
            this.$store.dispatch('SHOW_ALERT', err.message);
            reject();
          });
      });
    },
    async tsvDownLoadClick(){
      const items = await this.fetchAll();
      tsvDownLoad(this.schemas, items);
    },
    //カスケーダ処理
    handleFileSelection(value) {
      if (Array.isArray(value) && value.length > 0){
        this.searchForm.documentLink[0] = value[0];
        this.searchForm.documentLink[1] = value[1];
      } else {
        this.searchForm.documentLink = [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.search_unit {
  & .row {
    align-items: center;
  }
  & .el-form-item {
    margin-bottom: 24px
  }
  & .max-content {
    width: max-content;
  }
}
::v-deep .tw_table {
  background-color: #d6d6dc;
  &.el-table--border th, &.el-table--border td {
    border-right: 1px solid #BFBFCD;
  }
  & .el-table__body, & .el-table__header {     
    min-width: unset !important;
    & .gutter {
      border: none;
      background-color: #d6d6dc;
    }
  }
}
.tw_container {
  background: $color_white;
}
</style>

<style lang="scss">
.search-condition-dialog {
  & .el-dialog {
    display: flex;
    flex-direction: column;
    width: 70vw;
    height: 80vh;

    & .el-dialog__body {
      padding-bottom: 0;
      max-height: calc(100% - 100px);
      overflow: auto;
      & .row{
        &.detailed-conditions {
          border-top: 1px solid #BFBFCD;
          padding-top: 8px;
        }
      }
      & .el-select {
        width: 100%;
        & input {
          width: 100%;
        }
      }
      & .el-date-editor:has(input:not(:placeholder-shown)),
      & .el-input__inner:not(.el-date-editor):not(:placeholder-shown),
      & .el-select:has(.el-tag) .el-input .el-input__inner {
        background-color: rgba(#b2efcb, .3);
      }
    }

    & .el-dialog__footer {
      height: 100px;
    }
  }
}
</style>